import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "md:flex gap-2 md:gap-4 my-2 md:my-4 bg-[#1F1F1F] rounded-md p-2 md:p-4" }
const _hoisted_2 = { class: "mx-auto relative w-fit" }
const _hoisted_3 = { class: "h-72" }
const _hoisted_4 = {
  key: 0,
  class: "rounded-full p-1 bg-black text-yellow-400 w-6 h-6 absolute right-1 top-1"
}
const _hoisted_5 = { class: "w-full md:mt-0 mt-2 space-y-2" }
const _hoisted_6 = { class: "flex flex-start gap-2 md:gap-4" }
const _hoisted_7 = { class: "font-bold text-lg text-start text-gray-200 min-h-[2rem] w-full" }
const _hoisted_8 = { class: "flex gap-2 md:gap-2" }
const _hoisted_9 = { class: "flex items-center h-7 w-fit" }
const _hoisted_10 = { class: "text-white text-start md:w-28" }
const _hoisted_11 = { class: "flex flex-wrap gap-2" }
const _hoisted_12 = { class: "px-2 py-1 rounded-md text-[#D9D9D9] bg-[#4D4D4D] min-h-7 text-start cursor-pointer" }

import { Button, Divider, Tooltip } from 'ant-design-vue';
import { onMounted, ref, watch } from 'vue';
import { DeleteFilled, ExportOutlined, StarFilled, StarOutlined } from '@ant-design/icons-vue';
import ImageLoading from '@/components/shared/ImageLoading.vue';
import RatingStar from '@/components/shared/RatingStar.vue';
import { Doujin, DoujinSource } from '@/model/doujin';
import { getImage } from '@/repository/doujin';

interface Tag {
	type: 'tag' | 'rating';
	title: string;
	tags?: string[] | number;
	url?: (value: string) => string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DoujinView',
  props: {
    doujin: {}
  },
  emits: ["favorite", "delete", "rating"],
  setup(__props: any, { emit }) {

const props = __props;



const reload = ref(false);
const imageURL = ref(props.doujin.source === DoujinSource.NHentai ? '' : props.doujin.imageURL);
const yourRating = ref(0);
onMounted(async () => {
	try {
		reload.value = true;
		if (
			[
				DoujinSource.NHentai,
				DoujinSource.DoujinTH,
				DoujinSource.HentaiThai,
				DoujinSource.Koharu
			].includes(props.doujin.source as DoujinSource)
		) {
			const image = await getImage(props.doujin.imageURL);
			if (image && image.data) {
				imageURL.value = URL.createObjectURL(image.data);
			}
		}
		reload.value = false;
	} catch (error) {
		reload.value = false;
	}
});

watch(
	() => props.doujin.yourRating,
	(newRating) => {
		if (newRating !== yourRating.value) {
			yourRating.value = newRating || 0;
		}
	}
);



const buttons = [
	{
		tooltip: 'External Link',
		component: () => ExportOutlined,
		class: 'hover:bg-blue-500 bg-blue-400 !text-black',
		action: () => window.open(props.doujin.link, '_blank')
	},
	{
		tooltip: 'Favorite',
		component: () => (props.doujin.isFavorite ? StarFilled : StarOutlined),
		class: 'hover:bg-yellow-500 bg-yellow-400 !text-red-600',
		action: () => emit('favorite')
	},
	{
		tooltip: 'Delete',
		component: () => DeleteFilled,
		class: 'hover:bg-red-600 bg-red-500 !text-white hidden md:block',
		action: () => emit('delete')
	}
];

const tags = ref<Tag[]>([
	{
		type: 'tag',
		title: 'Source',
		tags: [props.doujin?.source],
		url: (value: string) => `/doujin?page=1&limit=10&source=${value}`
	},
	{
		type: 'tag',
		title: 'Code',
		tags: [props.doujin?.code],
		url: (value: string) => `/doujin?page=1&limit=10&search=${value.split('@')[0]}`
	},
	{
		type: 'tag',
		title: 'Artists',
		tags: props.doujin?.artists,
		url: (value: string) => `/doujin?page=1&limit=10&artists=${value}`
	},
	{
		type: 'tag',
		title: 'Characters',
		tags: props.doujin?.characters,
		url: (value: string) => `/doujin?page=1&limit=10&characters=${value}`
	},
	{
		type: 'tag',
		title: 'Tags',
		tags: props.doujin?.tags,
		url: (value: string) => `/doujin?page=1&limit=10&tags=${value}`
	},
	{
		type: 'rating',
		title: 'Your Rating'
	}
]);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ImageLoading, {
          previewable: "",
          src: imageURL.value,
          reload: reload.value,
          "img-class": "!h-72 !w-72",
          "loading-class": "h-72 w-72 m-auto md:m-0",
          isForceLoading: ""
        }, null, 8, ["src", "reload"])
      ]),
      (_ctx.doujin.isFavorite)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_unref(StarFilled))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.doujin.title), 1),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(buttons, (button, index) => {
            return _createVNode(_unref(Tooltip), {
              key: index,
              placement: "top"
            }, {
              title: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(button.tooltip), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(Button), {
                  class: _normalizeClass(["rounded-md", `${button.class} border-none`]),
                  onClick: ($event: any) => (button.action())
                }, {
                  icon: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(button.component())))
                  ]),
                  _: 2
                }, 1032, ["onClick", "class"])
              ]),
              _: 2
            }, 1024)
          }), 64))
        ])
      ]),
      _createVNode(_unref(Divider), { class: "bg-gray-600 my-0 md:!my-4" }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "md:flex"
        }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(tag.title) + ":", 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            (tag.type === 'rating')
              ? (_openBlock(), _createBlock(RatingStar, {
                  key: 0,
                  value: _ctx.doujin.yourRating!,
                  onRating: _cache[0] || (_cache[0] = (value) => emit('rating', value))
                }, null, 8, ["value"]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(tag.tags, (value, index) => {
                  return (_openBlock(), _createBlock(_component_RouterLink, {
                    key: index,
                    to: (tag.url && tag.url(`${value}`)) || ''
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(value), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                }), 128))
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})